import { useEffect, useState } from "react";
import { Bot, CreditCard, Database, MonitorSmartphone, ShieldCheck, Tags, UserRound } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "@/components/PageHeader";
import { ProfileCard } from "@/components/settings/ProfileCard";
import { SecurityCard } from "@/components/settings/SecurityCard";
import { MentorCard } from "@/components/settings/MentorCard";
import { DataCard } from "@/components/settings/DataCard";
import { SubscriptionCard } from "@/components/settings/SubscriptionCard";
import { InstallCard } from "@/components/settings/InstallCard";
import { CategoryGuide } from "@/components/settings/CategoryGuide";
import { api, formatApiError } from "@/lib/api";
import type { UserSettings } from "@/lib/settings";

const NAV = [
  { id: "perfil", label: "Perfil", icon: UserRound },
  { id: "seguridad", label: "Seguridad", icon: ShieldCheck },
  { id: "mentor", label: "Mi mentor", icon: Bot },
  { id: "datos", label: "Mis datos", icon: Database },
  { id: "suscripcion", label: "Suscripción", icon: CreditCard },
  { id: "instalar", label: "Instalar", icon: MonitorSmartphone },
  { id: "categorias", label: "Qué va en cada categoría", icon: Tags },
];

export default function SettingsPage() {
  const [data, setData] = useState<UserSettings | null>(null);
  useEffect(() => {
    api.get<UserSettings>("/settings").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <section data-testid="settings-page">
      <PageHeader title="Configuración" testId="settings-title" />
      <div className="grid gap-8 lg:grid-cols-[220px_1fr]">
        <nav className="hidden lg:block" data-testid="settings-nav">
          <ul className="sticky top-24 space-y-1">
            {NAV.map(({ id, label, icon: Icon }) => (
              <li key={id}>
                <a href={`#${id}`} className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-white hover:text-[#1B2A4A]" data-testid={`settings-nav-${id}`}>
                  <Icon className="h-4 w-4" /> {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        {!data ? <div className="h-96 animate-pulse rounded-[14px] bg-white" /> : (
          <div className="min-w-0 space-y-6">
            <ProfileCard data={data} onSaved={setData} />
            <SecurityCard />
            <MentorCard mentor={data.mentor} />
            <DataCard email={data.email} />
            <SubscriptionCard />
            <InstallCard />
            <CategoryGuide />
          </div>
        )}
      </div>
    </section>
  );
}
